export const PIN_CODE_KEYBOARD = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];
export const PIN_CODE_LENGTH = 6;
export const PIN_CODE_EMPTY_VALUES = Array.from({ length: PIN_CODE_LENGTH });
